
































































































import {Component, Vue} from "vue-property-decorator";
import UserEditDialog from "./UserEditDialog.vue"
import ConfirmDialog from "../ConfirmDialog.vue";
import {deepCopy} from "@/auxillary"
import {MdbsIdProvider} from "@/api/tsclient";
import {rolesModule, usersModule} from "@/store";

@Component({
  components: {
    UserEditDialog,
    ConfirmDialog
  },
})
export default class UserTable extends Vue {
  private _loading: boolean = false;

  headers: any = [
    {text: 'Anzeigename', value: 'displayName'},
    {text: 'Benutzername', value: 'userName'},
    {text: 'Rolle', value: 'role.displayName'},
    {text: 'Email', value: 'email'},
    {text: 'Aktionen', value: 'actions', sortable: false, width: "120px", align: "center"}
  ];
  options: any = {
    sortBy: ['displayName'],
    sortDesc: [false]
  };
  search: string = "";

  itemToDelete: MdbsIdProvider.ShortUserDto | null = null;
  itemToEdit: MdbsIdProvider.UserDto | null = null;

  get users() {
    return usersModule.users;
  }

  get loading() {
    return this._loading || usersModule.loading || rolesModule.loading;
  }

  get canCreateUser() {
    return true; //TODO Permission mgmgt
  }

  get canEditUser() {
    return true; //TODO Permission mgmgt
  }

  get canDeactivateUser() {
    return true; //TODO Permission mgmgt
  }

  async mounted() {
    await usersModule.loadAll();
    await rolesModule.loadAll();
  }

  showNewDialog() {
    this.itemToEdit = new MdbsIdProvider.UserDto();
  }

  showEditDialog(group: MdbsIdProvider.UserDto) {
    this.itemToEdit = deepCopy(group);
  }

  showDeleteDialog(group: MdbsIdProvider.UserDto) {
    this.itemToDelete = group;
  }

  async deleteItem() {
    if (this.itemToDelete?.id == null)
      return
    this._loading = true;
    const idToDelete = this.itemToDelete?.id;
    this.itemToDelete = null;
    await usersModule.deactivateUser(idToDelete)
    this._loading = false;
  }
}
